import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AbstractControl, FormArray, FormControl } from '@angular/forms';
import { IAutoCompleteData } from '../../interfaces/i-auto-complete-data';
import { IManager } from 'src/app/core/models/i-manager';
import { AppConfig } from 'src/app/app-config';
import { ISelectListItem } from '../../interfaces/i-select-list-item';
import { RELATED_MANAGER_FORM_PATHS } from '../related-manager-item/constants/form-paths';

@Component({
  selector: 'app-related-manager',
  templateUrl: './related-manager.component.html',
  styleUrls: ['./related-manager.component.scss'],
})
export class RelatedManagerComponent {
  @Input() selectedManagers: FormArray;
  @Input() searchResults: IAutoCompleteData[];
  @Input() searchFormControl: FormControl;

  @Input() isSearching: boolean;
  @Input() isLoadingManagerDetails: boolean;
  @Input() placeholder: string = 'Search';
  @Input() isSectorChangeShown: boolean = true;
  @Input() isSurtitleButtonShown: boolean = false;
  // View-only provenance from smart linking; empty everywhere smart linking is off.
  @Input() smartLinkedManagerIds: string[] = [];

  @Output() handleRemove = new EventEmitter();
  @Output() handleAdd = new EventEmitter();
  @Output() handleAddToBody = new EventEmitter<IManager>();
  @Output() handleInfoClick = new EventEmitter<IManager>();
  @Output() handleSectorChange = new EventEmitter();
  @Output() handlePromote = new EventEmitter<ISelectListItem>();

  constructor(public appConfig: AppConfig) {}

  onRemove(item: IManager) {
    this.handleRemove.emit(item);
  }

  onAdd(item: IManager) {
    this.handleAdd.emit(item);
  }

  onAddToBody(item: IManager) {
    this.handleAddToBody.emit(item);
  }

  onInfoClick(item: IManager) {
    this.handleInfoClick.emit(item);
  }

  onSectorChange() {
    this.handleSectorChange.emit();
  }

  onPromoteManagerToSurtitle(item: ISelectListItem) {
    this.handlePromote.emit(item);
  }

  isManagerSmartLinked(managerControl: AbstractControl): boolean {
    const manager = managerControl.get(
      RELATED_MANAGER_FORM_PATHS.SELECTED_MANAGER()
    )?.value;
    return !!manager && this.smartLinkedManagerIds.includes(`${manager.id}`);
  }
}
